import { render, staticRenderFns } from "./RevisionFiles.vue?vue&type=template&id=3b5efa44&scoped=true"
import script from "./RevisionFiles.vue?vue&type=script&lang=js"
export * from "./RevisionFiles.vue?vue&type=script&lang=js"
import style0 from "./RevisionFiles.vue?vue&type=style&index=0&id=3b5efa44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5efa44",
  null
  
)

export default component.exports